var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.quantity),function(value,key){return _c('div',{staticClass:"quantity"},[_c('name-value-vertical-with-unit',{attrs:{"name":_vm.maps[key]['name'],"value":_vm.transferValue(value),"unit":_vm.transferUnit(value,_vm.maps[key]['unit'])}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }